(function () {
  'use strict';

  var root = document.querySelector('[data-forestry-birthday-gift]');
  if (!root) return;

  var views = {
    loading: root.querySelector('[data-birthday-loading]'),
    signIn: root.querySelector('[data-birthday-sign-in]'),
    claiming: root.querySelector('[data-birthday-claiming]'),
    setup: root.querySelector('[data-birthday-setup]'),
    scheduled: root.querySelector('[data-birthday-scheduled]'),
    success: root.querySelector('[data-birthday-success]'),
    unavailable: root.querySelector('[data-birthday-unavailable]')
  };
  var claimInFlight = false;

  function show(name) {
    Object.keys(views).forEach(function (key) {
      views[key].hidden = key !== name;
    });
    root.querySelector('.ForestryBirthday__panel').setAttribute('data-birthday-state', name);
  }

  async function request(url, method, body) {
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = controller ? setTimeout(function () { controller.abort(); }, 15000) : null;
    try {
      var response = await fetch(url, {
        method: method,
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: body ? JSON.stringify(body) : undefined,
        signal: controller ? controller.signal : undefined
      });
      var payload = await response.json();
      return { ok: response.ok && payload && payload.ok === true, data: payload && payload.data || {}, error: payload && payload.error || null };
    } catch (error) {
      return { ok: false, data: {}, error: { code: 'network_error' } };
    } finally {
      if (timer) clearTimeout(timer);
    }
  }

  function availableCoupon(issuance) {
    return issuance && issuance.reward_type === 'discount_code' &&
      Number(issuance.reward_value) === 10 && issuance.is_usable === true &&
      typeof issuance.reward_code === 'string' && issuance.reward_code.length > 0;
  }

  function isClaimable(issuance) {
    return issuance && issuance.reward_type === 'discount_code' &&
      Number(issuance.reward_value) === 10 && issuance.status === 'issued';
  }

  function animate() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var mount = root.querySelector('[data-birthday-animation]');
    if (mount.querySelector('lottie-player')) return;
    var player = document.createElement('lottie-player');
    player.setAttribute('src', root.dataset.animationUrl);
    player.setAttribute('background', 'transparent');
    player.setAttribute('speed', '1');
    player.setAttribute('autoplay', '');
    player.setAttribute('aria-hidden', 'true');
    mount.appendChild(player);
  }

  function showCoupon(issuance) {
    root.querySelector('[data-birthday-code]').textContent = issuance.reward_code;
    var expiry = issuance.expires_at ? new Date(issuance.expires_at) : null;
    root.querySelector('[data-birthday-expiry]').textContent = expiry && !Number.isNaN(expiry.getTime())
      ? 'Use by ' + new Intl.DateTimeFormat('en-US', { month: 'long', day: 'numeric', year: 'numeric' }).format(expiry)
      : 'Use within your birthday coupon window';
    root.querySelector('[data-birthday-shop]').href = '/discount/' + encodeURIComponent(issuance.reward_code) + '?redirect=/collections/candle-bundles';
    show('success');
    animate();
  }

  function showUnavailable(title, message, retry) {
    root.querySelector('[data-birthday-unavailable-title]').textContent = title;
    root.querySelector('[data-birthday-unavailable-message]').textContent = message;
    root.querySelector('[data-birthday-retry]').hidden = !retry;
    show('unavailable');
  }

  function showSchedule(data) {
    var iso = data.next_coupon_email_date;
    var date = iso ? new Date(iso + 'T12:00:00') : null;
    var formatted = date && !Number.isNaN(date.getTime())
      ? new Intl.DateTimeFormat('en-US', { month: 'long', day: 'numeric', year: 'numeric' }).format(date)
      : null;
    if (!formatted) {
      showUnavailable('We could not find your next birthday date.', 'Please check your saved birthday or contact us for help.', false);
      return;
    }
    root.querySelector('[data-birthday-scheduled-message]').textContent = data.email_opted_in
      ? 'We plan to email your $10 birthday coupon on ' + formatted + '. Thank you for being part of our small business.'
      : 'Your next birthday is ' + formatted + '. Turn on marketing emails in your account to receive your $10 birthday coupon.';
    show('scheduled');
  }

  async function saveBirthday(event) {
    event.preventDefault();
    var form = event.currentTarget;
    var month = Number(form.elements.birth_month.value);
    var day = Number(form.elements.birth_day.value);
    var valid = Number.isInteger(month) && Number.isInteger(day) &&
      month >= 1 && month <= 12 && day >= 1 && day <= new Date(2028, month, 0).getDate();
    var error = root.querySelector('[data-birthday-form-error]');
    if (!valid) {
      error.textContent = 'Please enter a valid month and day.';
      error.hidden = false;
      return;
    }
    error.hidden = true;
    var result = await request(root.dataset.captureUrl, 'POST', {
      birth_month: month, birth_day: day, source: 'birthday_gift_page'
    });
    if (result.ok) {
      await load();
    } else {
      error.textContent = 'We could not save your birthday yet. Please try again.';
      error.hidden = false;
    }
  }

  async function claim() {
    if (claimInFlight) return;
    claimInFlight = true;
    show('claiming');
    var result = await request(root.dataset.claimUrl, 'POST');
    claimInFlight = false;
    var issuance = result.data && result.data.reward && result.data.reward.issuance;
    if (result.ok && availableCoupon(issuance)) {
      showCoupon(issuance);
      return;
    }
    showUnavailable('Your gift needs one more moment.', 'We could not finish adding the coupon. Please try again, or contact us and we will help.', true);
  }

  async function load() {
    show('loading');
    var result = await request(root.dataset.statusUrl, 'GET');
    if (!result.ok) {
      showUnavailable('We could not reach your gift just yet.', 'Please try again in a moment.', true);
      return;
    }
    if (result.data.state === 'unknown_customer' || !result.data.profile_id) {
      if (root.dataset.signedIn === 'true') {
        showUnavailable('We are connecting your account.', 'Please try again in a moment. If your gift still does not appear, contact us and we will help.', true);
      } else {
        show('signIn');
      }
      return;
    }
    var issuance = result.data.reward && result.data.reward.issuance;
    if (availableCoupon(issuance)) {
      showCoupon(issuance);
    } else if (isClaimable(issuance)) {
      await claim();
    } else if (issuance && (issuance.status === 'expired' || issuance.is_expired)) {
      showUnavailable('This birthday coupon has expired.', 'If you think there has been a mistake, contact us and we will take a look.', false);
    } else if (!result.data.birthday || !result.data.birthday.birth_month || !result.data.birthday.birth_day) {
      show('setup');
    } else if (result.data.next_coupon_email_date) {
      showSchedule(result.data);
    } else {
      showUnavailable('We could not find your $10 birthday coupon yet.', 'Please check that you signed in with the email that received your birthday message. If you need help, we are here.', false);
    }
  }

  root.querySelector('[data-birthday-retry]').addEventListener('click', load);
  root.querySelector('[data-birthday-form]').addEventListener('submit', saveBirthday);
  root.querySelector('[data-birthday-login]').href = root.dataset.loginUrl;
  load();
})();
